<template>
    <div>
        <el-table class="coin-table" :data="currencyList" row-key="row-key">
          <el-table-column prop="id" fixed="left" label="ID"></el-table-column>
          <el-table-column label="币种" width="150px">
                <template slot-scope="scope">
                    <div class="logo">
                        <img :src="scope.row.logo"/>
                        {{ scope.row.coinType }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="充值">
                <template slot-scope="scope">
                    <el-switch
                            active-color="#13ce66"
                            @change="handleStatusChange(scope.row.coinType, 'deposit', $event)"
                            :value="scope.row.supportDeposit"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="提现">
                <template slot-scope="scope">
                    <el-switch
                            active-color="#13ce66"
                            @change="handleStatusChange(scope.row.coinType, 'withdraw', $event)"
                            :value="scope.row.supportWithdraw"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="交易">
                <template slot-scope="scope">
                    <el-switch
                            active-color="#13ce66"
                            @change="handleTradeStatusChange(scope.row.coinType, $event)"
                            :value="scope.row.supportTrade"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="聚合交易">
                <template slot-scope="scope">
                    <el-switch
                            active-color="#13ce66"
                            @change="handleAggregateTradeStatusChange(scope.row.coinType, $event)"
                            :value="scope.row.supportPolymerTrade"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="展示">
                <template slot-scope="scope">
                    <el-switch
                            active-color="#13ce66"
                            @change="handleDisplayChange(scope.row.coinType, $event)"
                            :value="scope.row.shouldDisplay"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="区域" width="150px">
                <template slot-scope="scope">
<!--                    <el-switch
                            active-color="#13ce66"
                            @change="handleAreaTypeChange(scope.row.coinType, $event)"
                            :value="!scope.row.areaType"></el-switch>-->
                  <el-radio-group
                      v-model="scope.row.areaType"
                      @change="handleAreaTypeChange(scope.row.coinType, scope.row.areaType)"
                  >
                    <div class="radio-item"><el-radio :label="0">主区</el-radio></div>
                    <div class="radio-item"><el-radio :label="1">创新区</el-radio></div>
                    <div class="radio-item"><el-radio :label="2">DRWA</el-radio></div>
                    <div class="radio-item"><el-radio :label="3">股票RWA</el-radio></div>
                  </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column label="是否需要读取钱包数据(一般勿动)">
                <template slot-scope="scope">
                    <el-switch
                            active-color="#13ce66"
                            @change="hadnlePutOnShelvesChange(scope.row.coinType, $event)"
                            :value="scope.row.putOnShelves"
                    ></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="depositWalletId" label="充值钱包服务器">
                <template slot-scope="scope">{{scope.row.depositWalletId | dealDepositWalletId}}</template>
            </el-table-column>
            <el-table-column prop="withdrawWalletId" label="提现钱包服务器"></el-table-column>
            <el-table-column prop="minimumTradeAmount" label="最小交易额"></el-table-column>
            <el-table-column prop="minChainDepositAmt" label="最小充值额"></el-table-column>
            <el-table-column prop="withdrawFee" label="提现手续费"></el-table-column>
            <el-table-column label="单笔提现额度">
                <template
                        slot-scope="scope"
                >{{scope.row.minWithdrawSingle}} ~ {{scope.row.maxWithdrawSingle}}
                </template>
            </el-table-column>
            <el-table-column prop="maxWithdrawOneDay" label="当日提现额度"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200px">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-edit" circle size="small" @click="handleEdit(scope.row)"/>
                    <el-button type="primary" icon="el-icon-share" circle size="small"
                               @click="openDialogUpdateWalletAccountStatus(scope.row)"/>
                    <el-button type="success" icon="el-icon-upload2" circle size="small"
                               @click="stickCoin(scope.row.coinType)"/>
                    <el-button type="danger" icon="el-icon-delete" circle size="small"
                               @click="handleRemove(scope.row.coinType)"/>
                </template>
            </el-table-column>
        </el-table>
        <pagination
                :size="pagination.size"
                :page="pagination.page"
                :total="totalCount"
                @pageChanged="handlePageChanged"
        ></pagination>

        <el-dialog title="更新币种各钱包账户转账状态" :visible.sync="showDialog">
            <el-form label-width="150px">
                <el-form-item label="币种">
                    <el-input v-model="walletStatusInfo.coinType" :disabled="true"/>
                </el-form-item>
                <el-form-item label="账户类型">
                    <el-select v-model="walletStatusInfo.walletType" @change="buildWalletInfo()">
                        <el-option
                                v-for="item in walletTypes"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="转账方向">
                    <el-select v-model="walletStatusInfo.direction" @change="buildWalletInfo()">
                        <el-option
                                v-for="item in directions"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch v-model="walletStatusInfo.status" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button @click="updateCoinDepositStatusSubmit(walletStatusInfo)" type="primary">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapMutations, mapState} from "vuex";
    import Pagination from "components/pagination";
    import SortableMixin from "mixins/SortableMixin";
    import api from '../../api';

    export default {
        name: "CurrencyList",
        mixins: [SortableMixin],
        components: {
            Pagination
        },
        data() {
            return {
                sortable: ".coin-table",
                showDialog: false,
                walletStatusInfo: {
                    coinType: "",
                    walletType: "WALLET",
                    direction: "IN",
                    status: false
                },
                walletTypes: [
                    {name: "我的钱包", code: "WALLET"},
                    //{name: '交易账户', code: 'SPOT'},
                    {name: '杠杆账户', code: 'MARGIN'},
                    {name: "法币账户", code: "OTC"},
                    {name: '合约账户', code: 'CONTRACT'},
                    //{name: '理财账户', code: 'FINANCIAL'},
                    {name: '超级合约账户账户', code: 'GENERAL'},
                ],
                directions: [{name: "转入", code: "IN"}, {name: "转出", code: "OUT"}],
                transferStatus: {
                    walletTransferIn: false,
                    walletTransferOut: false,
                    otcTransferIn: false,
                    otcTransferOut: false,
                    marginTransferIn: false,
                    marginTransferOut: false,
                    contractTransferIn: false,
                    contractTransferOut: false,
                    generalTransferIn: false,
                    generalTransferOut: false
                }
            };
        },
        computed: {
            ...mapGetters("currencySetting", ["currencyList"]),
            ...mapState("currencySetting", ["pagination", "totalCount"])
        },
        filters: {
            dealDepositWalletId(val) {
                if (val == null || val == "") {
                    return "";
                } else {
                    return JSON.parse(val)[0];
                }
            }
        },
        methods: {
            ...mapMutations("currencySetting", ["toggleDetailDialogVisible"]),
            ...mapActions("currencySetting", [
                "list",
                "updateDepositStatus",
                "updateWithdrawStatus",
                "updateTradeStatus",
                "updateDisplayStatus",
                "updateAreaType",
                "updateShelve",
                "updateSort",
                "detail",
                "remove",
                "updateCoinDepositStatus",
                "updateAggregateTradeStatus"
            ]),
            handleStatusChange(coinType, type, status) {
                const message =
                    type === "deposit"
                        ? `确认要${status ? "开启" : "关闭"}充值功能吗？`
                        : `确认要${status ? "开启" : "关闭"}提现功能吗？`;

                this.$confirm(message, "提示", {type: "warning "}).then(() => {
                    const action =
                        type === "deposit"
                            ? this.updateDepositStatus
                            : this.updateWithdrawStatus;

                    action({coinType, status}).then(() => {
                        this.$message.success("操作成功！");
                        this.$emit("refresh");
                    });
                });
            },
            handleTradeStatusChange(coinType, status) {
                const message = status
                    ? "确认要开启交易功能吗？"
                    : "确认要关闭交易功能吗？关闭该币种交易功能，相关的交易对交易功能也将关闭。";

                this.$confirm(message, "提示", {type: "warning"}).then(() => {
                    this.updateTradeStatus({coinType, status}).then(() => {
                        this.$message.success("操作成功！");
                        this.$emit("refresh");
                    });
                });
            },
            handleAggregateTradeStatusChange(coinType, status) {
                const message = status
                    ? "确认要开启聚合交易功能吗？"
                    : "确认要关闭聚合交易功能吗？关闭该币种交易功能，相关的交易对交易功能也将关闭。";

                this.$confirm(message, "提示", {type: "warning"}).then(() => {
                    this.updateAggregateTradeStatus({coinType, status}).then(() => {
                        this.$message.success("操作成功！");
                        this.$emit("refresh");
                    });
                });
            },
            handleDisplayChange(coinType, status) {
                this.$confirm("确认要进行此操作吗？", "提示", {type: "warning"}).then(() => {
                        this.updateDisplayStatus({coinType, status}).then(() => {
                            this.$message.success("操作成功！");
                            this.$emit("refresh");
                        });
                    }
                );
            },
            /*handleAreaTypeChange(coinType, status) {
                this.$confirm("确认要进行此操作吗？", "提示", {type: "warning"}).then(
                    () => {
                        this.updateAreaType({coinType, type: +!status}).then(() => {
                            this.$message.success("操作成功！");
                            this.$emit("refresh");
                        });
                    }
                );
            },*/
          handleAreaTypeChange(coinType, newAreaType) {
            console.log(coinType, newAreaType);
            this.$confirm('确认要将该币种切换到新区域吗？', '提示', { type: 'warning' })
                .then(() => this.updateAreaType({ coinType, type: newAreaType }))
                .then(() => {
                  this.$message.success('操作成功！');
                  this.$emit('refresh');
                })
                .catch(err => {
                  // 如果用户点了“取消”，不用处理；如果 action 失败，可选地给一个提示
                  if (err && err !== 'cancel') {
                    this.$message.error('更新失败，请重试');
                  }
                });
          },
          hadnlePutOnShelvesChange(coinType, status) {
                const message = status
                    ? "开启后，monitor会开始读取该币种钱包数据，确认吗？"
                    : "关闭后，monitor不会读取该币种钱包数据，确认吗？";

                this.$confirm(message, "提示", {type: "warning"}).then(() => {
                    this.updateShelve({coinType, status}).then(() => {
                        this.$message.success("操作成功！");
                        this.$emit("refresh");
                    });
                });
            },
            handleEdit(currency) {
                this.detail(currency.coinType);
                this.toggleDetailDialogVisible(true);
            },
            handleRemove(code) {
                this.$confirm("确认要删除该币种吗？", "提示", {type: "warning"}).then(
                    () => {
                        this.remove(code).then(() => {
                            this.$message.success("删除成功！");
                            this.$emit("refresh");
                        });
                    }
                );
            },
            handlePageChanged(pagination) {
                this.$emit("refresh", pagination);
            },

            stickCoin(coinType) {
                this.updateSort({coinType: coinType, orderNo: 1}).then(() => {
                    this.$message.success("更新成功！");
                    this.$emit("refresh");
                });
            },

            /**更新币种各钱包账户转账状态*/
            openDialogUpdateWalletAccountStatus(info) {
                this.transferStatus.walletTransferIn = info.walletTransferIn;
                this.transferStatus.walletTransferOut = info.walletTransferOut;
                this.transferStatus.otcTransferIn = info.otcTransferIn;
                this.transferStatus.otcTransferOut = info.otcTransferOut;
                this.transferStatus.marginTransferIn = info.marginTransferIn;
                this.transferStatus.marginTransferOut = info.marginTransferOut;
                this.transferStatus.contractTransferIn = info.contractTransferIn;
                this.transferStatus.contractTransferOut = info.contractTransferOut;
                this.transferStatus.generalTransferIn = info.generalTransferIn;
                this.transferStatus.generalTransferOut = info.generalTransferOut;

                //给钱包状态赋值
                this.walletStatusInfo.coinType = info.coinType;
                this.walletStatusInfo.direction = "IN";
                this.walletStatusInfo.walletType = "WALLET";
                this.walletStatusInfo.status = this.transferStatus.walletTransferIn;
                this.showDialog = true;
            },

            buildWalletInfo() {
                if (this.walletStatusInfo.direction === "IN") {
                    if (this.walletStatusInfo.walletType === "WALLET") {
                        this.walletStatusInfo.status = this.transferStatus.walletTransferIn;
                    }
                    if (this.walletStatusInfo.walletType === "OTC") {
                        this.walletStatusInfo.status = this.transferStatus.otcTransferIn;
                    }
                    if (this.walletStatusInfo.walletType === "CONTRACT") {
                        this.walletStatusInfo.status = this.transferStatus.contractTransferIn;
                    }
                    if (this.walletStatusInfo.walletType === "GENERAL") {
                        this.walletStatusInfo.status = this.transferStatus.generalTransferIn;
                    }
                    if (this.walletStatusInfo.walletType === "MARGIN") {
                        this.walletStatusInfo.status = this.transferStatus.marginTransferIn;
                    }
                }
                if (this.walletStatusInfo.direction === "OUT") {
                    if (this.walletStatusInfo.walletType === "WALLET") {
                        this.walletStatusInfo.status = this.transferStatus.walletTransferOut;
                    }
                    if (this.walletStatusInfo.walletType === "OTC") {
                        this.walletStatusInfo.status = this.transferStatus.otcTransferOut;
                    }
                    if (this.walletStatusInfo.walletType === "CONTRACT") {
                        this.walletStatusInfo.status = this.transferStatus.contractTransferOut;
                    }
                    if (this.walletStatusInfo.walletType === "GENERAL") {
                        this.walletStatusInfo.status = this.transferStatus.generalTransferOut;
                    }
                    if (this.walletStatusInfo.walletType === "MARGIN") {
                        this.walletStatusInfo.status = this.transferStatus.marginTransferOut;
                    }
                }
            },

            updateCoinDepositStatusSubmit(data) {
                this.updateCoinDepositStatus(data).then(() => {
                    this.$message.success("更新成功");
                    this.showDialog = false;
                });
            },
            onSort(evt) {
                const {oldIndex, newIndex} = evt;
                const {page, size} = this.pagination;
                console.log((page - 1) * size + newIndex + 1)
                if (oldIndex !== newIndex) {
                    console.log(this.currencyList[oldIndex])
                    const coinType = this.currencyList[oldIndex].coinType;
                    api.dragSort({coinType: coinType, orderNo: (page - 1) * size + newIndex + 1}).then(() => {
                        this.$message.success('更新成功！');
                        this.$emit('refresh');
                    });
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .logo {
        display: flex;
        align-items: center;

        img {
            margin-right: 8px;
            width: 44px;
            height: 44px;
            border: 0;
        }
    }

    .vertical-radio-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

</style>
